export const SERVICE_DATE_TIMEZONE_HELPER_TEXT =
  "Select the client's timezone for the date of service.";

export const SERVICE_DATE_TIMEZONE_PROVIDER_MESSAGE = "The date must match the client's timezone.";

export const TIMEZONE_CODING_SYSTEM = "urn:ietf:params:tz";

export const DEFAULT_SERVICE_DATE_TIMEZONE = {
  system: TIMEZONE_CODING_SYSTEM,
  code: "America/Los_Angeles",
  display: "(GMT-07:00) Pacific Time - Los Angeles",
} as const;
